import React from 'react';
import { useReactiveVar } from '@apollo/client';
import { useFormikContext } from 'formik';
import { selectedTextSnippetVar } from 'components/text-editor/components/controls/hooks/use-selected-text-snippet';
import { isFunction } from 'lodash';
import { notEqual } from 'utils';
import { CustomEditor } from 'components/text-editor/hooks/use-custom-editor';
import { Editor } from 'slate';

export default function useTextSelectionListeners(editor: CustomEditor) {
  const selectedTextSnippet = useReactiveVar(selectedTextSnippetVar);

  const previousSelectedSnippetNodeRef = React.useRef<any>();

  const { isSubmitting } = useFormikContext();

  React.useEffect(() => {
    isSubmitting && editor.unMarkNodesAsSelected();
  }, [isSubmitting]);

  React.useEffect(() => {
    editor?.unMarkNodesAsSelected && editor?.unMarkNodesAsSelected();
  }, []);

  React.useEffect(() => {
    if (editor.selection) {
      const [node] = Editor.node(editor, editor.selection);

      const selectedText = window.getSelection()?.toString()?.trim();

      if (selectedText) {
        //@ts-ignore
        const selectedTextSnippetNode = node?.annotationId
          ? (node as any)
          : null;

        const isDifferentSnippet =
          selectedTextSnippetNode?.annotationId !==
          previousSelectedSnippetNodeRef.current?.annotationId;

        if (selectedTextSnippetNode) {
          if (isDifferentSnippet) {
            previousSelectedSnippetNodeRef.current = selectedTextSnippetNode;
            editor.unMarkNodesAsSelected();

            //@ts-ignore
            const annotationId = selectedTextSnippetNode.annotationId;

            const at = editor.getSlateRangeByAnnotationId(annotationId);

            editor.updateAnnotation({ isSelected: true, annotationId }, { at });

            setSelectedTextSnippet(selectedTextSnippetNode);
          }
        }
      } else {
        if (
          selectedTextSnippet &&
          node &&
          notEqual(selectedTextSnippet, node)
        ) {
          previousSelectedSnippetNodeRef.current = undefined;
          editor.unMarkNodesAsSelected();
          clearSelectedTextSnippet();
        }
      }
    }
  }, [editor.selection]);
}

function clearSelectedTextSnippet() {
  setSelectedTextSnippet(undefined);
}

function setSelectedTextSnippet(selectedTextSnippet) {
  if (isFunction(selectedTextSnippet)) {
    return selectedTextSnippetVar(
      selectedTextSnippet(selectedTextSnippetVar()),
    );
  }

  selectedTextSnippetVar(selectedTextSnippet);
}
